<app-nav-bar [links]="navBarLinksVisible === true ? navBarlinks : []"
    [rightButton]="navBarRightButton !== null ? navBarRightButton : null" [textColor]="navBarTextColor"
    [background]="navBarBackground" [overlay]="navBarOverlay"></app-nav-bar>
<main [class.overlay]="navBarOverlay" [class.float]="!navBarOverlay">
    <router-outlet></router-outlet>
</main>
<app-footer *ngIf="footerVisible"></app-footer>
<!--<button mat-fab class="back-to-top" color="accent" (click)="backToTop()">
    <mat-icon>keyboard_arrow_up</mat-icon>
</button>-->